import { svc_getIncludedAccountBalances } from '../services/account.service';

export const getAccountsListAndAvailableBalance = async (accessToken, userId) => {
    const { data, error } = await getAccountsAndBalances(accessToken, userId);

    if (error) {
        console.error("Error getting accounts and balances: ", error);
    }

    return {
        data: {
            accountsList: data.accounts,
            availableBalance: data.combinedBalance
        },
        error
    }
}

export const getAccountsAndBalances = async (accessToken, userId) => {
    const returnData = {
        data: {
            accounts: null,
            combinedBalance: null
        },
        error: null
    }

    const { data, error } = await svc_getIncludedAccountBalances(accessToken, userId);

    if (error) {
        returnData.error = error
        return returnData
    }

    let { result } = await data[0]

    if (typeof result === 'string') {
        result = JSON.parse(result)
    }

    const manualAccounts = result.accounts?.map((account) => {
        return {
            id: account.id,
            available_balance: account.available_balance
        }
    }) || [];

    const obAccounts = result.obCustomerAccounts?.map((obAccount) => {
        return {
            id: obAccount.id,
            available_balance: obAccount.data.balance
        }
    }) || [];

    const allAccounts = manualAccounts.concat(obAccounts)

    returnData.error = error

    if (allAccounts.length) {
        const combinedBalance = allAccounts
            .map((account) => account.available_balance)
            .reduce((prev, current) => prev + current, 0)

        returnData.data.accounts = allAccounts
        returnData.data.combinedBalance = combinedBalance
    }

    return returnData
}